import { Navigate, useLocation } from "react-router-dom";
import { useAdminAuth } from "@/lib/adminAuth";

// Guards admin routes: requires a session; optionally requires role="saadmin".
export const AdminGuard = ({ children, requireSuper = false }) => {
  const loc = useLocation();
  const { session } = useAdminAuth();
  if (!session) {
    return <Navigate to="/admin/login" replace state={{ from: loc.pathname }} />;
  }
  if (requireSuper && session.role !== "saadmin") {
    return <Navigate to="/admin" replace />;
  }
  return children;
};
